<template>
  <base-input :rules="internalRules" :errors="errors" :class="$attrs.class">
    <div
      :class="[
        'relative border rounded-md focus-within:ring-1 ring-0 flex items-center transition-all ease-in-out duration-100 bg-white z-10 mt-1',
        `focus-within:ring-${focusColor} focus-within:border-${focusColor} border-${borderColor}`,
      ]"
    >
      <label :class="['absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-normal', `text-${labelColor}`]" v-if="label">{{ label }}</label>
      <textarea
        v-bind="inputAttrs"
        type="text"
        :class="['form-input flex-grow block w-full border-0 px-3 py-2 rounded-md text-gray-900 focus:ring-0 font-light', `placeholder-${placeholderColor} sm:text-${size}`]"
        :placeholder="placeholder"
        @blur="validate"
        @input="$emit('update:modelValue', $event.target.value)"
        :value="modelValue"
        :rows="rows"
      />
    </div>
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";
import BaseInput from "@/components/base/BaseInput";

export default {
  inheritAttrs: false,
  mixins: [validatable],
  components: {
    BaseInput,
  },
  props: {
    modelValue: [String, Number],
    label: String,
    placeholder: String,
    size: {
      type: String,
      default: "sm",
    },
    rows: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
    inputAttrs() {
      const rest = { ...this.$attrs };
      delete rest.class;
      return rest;
    },
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("update:modelValue", null);
    },
  },
};
</script>
